import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsWebhookEventsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Event types</div>
          <div className="text">This is a list of all types of events we send.</div>
          <APIDocsTable
            title="Event"
            rows={[
              {
                description: 'Occurs when a new post is created.',
                heading: 'post.created',
              },
              {
                description: 'Occurs when a post is edited.',
                heading: 'post.edited',
              },
              {
                description: 'Occurs when a post is deleted.',
                heading: 'post.deleted',
              },
              {
                description: 'Occurs when a Jira issue is linked to a post.',
                heading: 'post.jira_issue_linked',
              },
              {
                description: 'Occurs when a Jira issue is unlinked from a post.',
                heading: 'post.jira_issue_unlinked',
              },
              {
                description: 'Occurs when a post is tagged',
                heading: 'post.tag_added',
              },
              {
                description: "Occurs when a post's tag is removed.",
                heading: 'post.tag_removed',
              },
              {
                description: "Occurs when a post's status is changed.",
                heading: 'post.status_changed',
              },
              {
                description: 'Occurs when a new comment is created.',
                heading: 'comment.created',
              },
              {
                description: 'Occurs when a comment is edited.',
                heading: 'comment.edited',
              },
              {
                description: 'Occurs when a comment is deleted.',
                heading: 'comment.deleted',
              },
              {
                description: 'Occurs when a user votes on a post.',
                heading: 'vote.created',
              },
              {
                description: 'Occurs when a user unvotes on a post.',
                heading: 'vote.deleted',
              },
            ]}
          />
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
